module.exports = __webpack_public_path__ + "static/media/matlab_logo.9eb16100.png";